import { render, staticRenderFns } from "./ProductionTaskType.vue?vue&type=template&id=6227b176&scoped=true&"
import script from "./ProductionTaskType.vue?vue&type=script&lang=js&"
export * from "./ProductionTaskType.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTaskType.vue?vue&type=style&index=0&id=6227b176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227b176",
  null
  
)

export default component.exports